import MetamaskModal from "../common/modal/metamaskModal/MetamaskModal";
import GlobalStyles from "../assets/styles/GlobalStyles";
import Layout from "../common/layout";
import Header from "../components/section/header/v1";
import Wizard from "../components/section/wizard";
import WalletModal from "../common/modal/walletModal/WalletModal";
import NetworkModal from "../common/modal/networkModal/NetworkModal";
import { useModal } from "../utils/ModalContext";
import { useEffect } from "react";
import { getChainId, onChainChange } from "../lib/metamaskhandler";

const WizardStep = () => {
  const {
    metamaskModal,
    walletModalvisibility,
    network,
    setNetwork,
    setNetworkModalVisibility,
    networkModalVisibility,
  } = useModal();

  onChainChange(network, setNetwork, setNetworkModalVisibility);

  useEffect(() => {
    if (window.ethereum) {
      const getNetwork = async () => {
        if ((await getChainId()) != network) {
          setNetworkModalVisibility(true);
        }
      };

      getNetwork();
    }
  }, [network]);
  return (
    <>
      <Layout>
        <GlobalStyles />
        {/* {metamaskModal && <MetamaskModal />} */}
        {walletModalvisibility && <WalletModal />}
        {/* {networkModalVisibility && <NetworkModal />} */}
        <Header />
        <Wizard />
      </Layout>
    </>
  );
};

export default WizardStep;
